// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";

function fromJson(value) {
  var dict = Core__JSON.Classify.classify(value);
  if (typeof dict !== "object") {
    return ;
  }
  switch (dict.TAG) {
    case "Bool" :
        return "Bool";
    case "String" :
        return "String";
    case "Number" :
        return "Float";
    case "Object" :
        return {
                TAG: "Object",
                _0: Core__Array.filterMap(Object.entries(dict._0), (function (param) {
                        var key = param[0];
                        return Core__Option.map(fromJson(param[1]), (function (value) {
                                      return {
                                              key: key,
                                              value: value
                                            };
                                    }));
                      }))
              };
    case "Array" :
        return Core__Option.map(Core__Option.flatMap(dict._0[0], fromJson), (function (x) {
                      return {
                              TAG: "List",
                              _0: x
                            };
                    }));
    
  }
}

export {
  fromJson ,
}
/* No side effect */
